var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg004MediaSharing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.376 41.582V18.728a3.258 3.258 0 0 0-3.254-3.254H13.961a3.258 3.258 0 0 0-3.254 3.254v22.854a3.258 3.258 0 0 0 3.254 3.254h30.161a3.258 3.258 0 0 0 3.254-3.254zM13.961 17.474h30.161a1.255 1.255 0 0 1 1.254 1.254v16.68L39 29.05a1 1 0 0 0-1.1-.211L30.09 32.19l-5.559-5.542a1.001 1.001 0 0 0-1.1-.21l-10.725 4.6V18.728a1.255 1.255 0 0 1 1.254-1.254zm-1.254 24.108v-8.367l10.892-4.672c2.156 2.152 6.96 6.936 9.07 9.041a1 1 0 0 0 1.412-1.416l-2.463-2.455 6.448-2.769 7.31 7.287v3.35a1.255 1.255 0 0 1-1.254 1.255H13.961a1.255 1.255 0 0 1-1.254-1.254z",
    fill: "#a59887",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.475 26.197a3.26 3.26 0 0 0 0-6.518 3.26 3.26 0 0 0 0 6.518zm0-4.518a1.26 1.26 0 0 1 0 2.518 1.26 1.26 0 0 1 0-2.518zM12.81 48.49a1.08 1.08 0 0 0 0 2.16 1.08 1.08 0 0 0 0-2.16zM17.124 48.49a1.08 1.08 0 0 0 0 2.16 1.08 1.08 0 0 0 0-2.16zM21.438 48.49a1.08 1.08 0 0 0 0 2.16 1.08 1.08 0 0 0 0-2.16zM27.974 11.82a1.08 1.08 0 0 0 0-2.16 1.08 1.08 0 0 0 0 2.16zM12.81 11.74h9.711a1 1 0 0 0 0-2H12.81a1 1 0 0 0 0 2z",
    fill: "#a59887",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.053 43.866V7.149A3.15 3.15 0 0 0 49.908 4H8.175a3.15 3.15 0 0 0-3.146 3.15v46.01a3.15 3.15 0 0 0 3.146 3.15h35.653c4.44 6.705 15.109 3.627 15.143-4.548a8.253 8.253 0 0 0-5.918-7.896zM8.175 54.31a1.149 1.149 0 0 1-1.146-1.15V7.15A1.149 1.149 0 0 1 8.175 6h41.733a1.148 1.148 0 0 1 1.145 1.15v36.39c-.115-.004-.227-.017-.343-.017a8.26 8.26 0 0 0-8.26 8.239 8.177 8.177 0 0 0 .408 2.548zM50.71 58a6.257 6.257 0 0 1-6.26-6.238c.293-8.257 12.228-8.254 12.52 0A6.257 6.257 0 0 1 50.71 58z",
    fill: "#a59887",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.42 47.224a1.001 1.001 0 0 0-1.416-.005l-3.228 3.217a1 1 0 0 0 1.413 1.416l1.521-1.517v5.261a1 1 0 0 0 2 0v-5.26l1.52 1.516a1 1 0 0 0 1.413-1.416z",
    fill: "#a59887",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg004MediaSharing);
export default __webpack_public_path__ + "static/media/004-media-sharing.24370b10e71816ce56b73d082509e6a7.svg";
export { ForwardRef as ReactComponent };